/* ABB – offertkorg i varukorgen (pass 17, 2026-10-13)
 * Lägger en ruta "Skicka förfrågan med logga" vid kassaknappen i varukorgen (låda + sida).
 * Knappen öppnar offertmodalen (abb-home.js, [data-abb-open]) förifylld med varukorgens innehåll och
 * ett UPPSKATTAT pris med logga. Uppskattningen är bara information i förfrågan – kassan tar alltid Shopifys pris,
 * och rader med _offert spärras från kassan i abb-moms.js.
 */
(function () {
  'use strict';
  var VERSION = '2026-10-13.2'; // pass 19: _utanlogga-rader = färdiga varor
  var VAT = 1.25;
  var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"], a[href^="/checkout"]';
  // Husregel grossistplagg: plagg = rek exkl. moms × 0,85 + dekor (Thorgerzon), steg på hela orderns antal
  var DEKOR = { brodyr: [300, 160, 110], tryck: [170, 100, 90] };
  // Fastställd pristrappa (kr/st exkl. moms, tryck/brodyr och frakt ingår)
  var TRAPPA = {
    keps: [599, 499, 449, 199, 189, 169, 149],
    mossa: [399, 349, 239, 199, 189, 179, 179],
    tshirt230: [399, 299, 279, 249, 219, 199, 179],
    tshirt310: [499, 399, 379, 349, 299, 289, 279],
    hoodie380: [749, 649, 599, 579, 529, 499, 479],
    hoodie500: [799, 699, 649, 599, 549, 529, 499]
  };
  var TRAPPA_STEG = [1, 5, 10, 25, 50, 75, 100];
  var RESELLERS = ['blåkläder', 'blaklader', 'projob', 'blackhill', 'black hill', 'teejays', 'tee jays', 'texstar', 'top swede', 'south west', 'matterhorn', 'monitor', 'sundström', 'cederroth', 'guardio', 'cofra', 'sixton'];

  function kr(n) { return Math.round(n).toLocaleString('sv-SE') + ' kr'; }
  function dekorSteg(q) { return q >= 10 ? 2 : q >= 5 ? 1 : 0; }
  function trappaSteg(q) { var i = 0; for (var k = 0; k < TRAPPA_STEG.length; k++) if (q >= TRAPPA_STEG[k]) i = k; return i; }
  function ownRow(it) {
    if (!flag(it, '_offert') || !/artbybearded/i.test(it.vendor || '') || /designa-custom-keps/.test(it.handle || '')) return null;
    var t = (it.product_type || '').toLowerCase(), s = ((it.product_title || '') + ' ' + (it.handle || '')).toLowerCase();
    if (t === 'keps' || t === 'kepsar') return 'keps';
    if (t.indexOf('mössa') !== -1 || t.indexOf('mössor') !== -1) return 'mossa';
    if (t.indexOf('t-shirt') !== -1) return s.indexOf('310') !== -1 ? 'tshirt310' : 'tshirt230';
    if (t.indexOf('hoodie') !== -1) return s.indexOf('500') !== -1 ? 'hoodie500' : 'hoodie380';
    return null;
  }
  function isReseller(it) { return !flag(it, '_utanlogga') && RESELLERS.indexOf(String(it.vendor || '').toLowerCase()) !== -1 && Number(it.final_price) > 100; }
  function flag(it, k) { return it.properties && (it.properties[k] === '1' || it.properties[k] === 1); }

  function summarize(cart) {
    var items = cart.items || [];
    if (!items.length) return null;
    var logoQty = 0, perRow = {};
    items.forEach(function (it) {
      var row = ownRow(it);
      if (row) perRow[row] = (perRow[row] || 0) + it.quantity;
      else if (isReseller(it)) logoQty += it.quantity;
    });
    var lines = [], total = 0, unknown = 0, qtyAll = 0, anyLogo = false;
    items.forEach(function (it) {
      qtyAll += it.quantity;
      var name = it.product_title + (it.variant_title ? ' – ' + it.variant_title : '');
      var row = ownRow(it), est = null, how = '';
      if (row && TRAPPA[row]) { est = TRAPPA[row][trappaSteg(perRow[row])]; how = 'inkl. logga och frakt'; anyLogo = true; }
      else if (isReseller(it)) {
        var plagg = Math.round(Number(it.final_price) / 100 / VAT * 0.85);
        est = plagg + DEKOR.brodyr[dekorSteg(logoQty)]; how = 'med brodyr på bröstet (tryck ' + kr(plagg + DEKOR.tryck[dekorSteg(logoQty)]) + ')'; anyLogo = true;
      } else if (!flag(it, '_offert')) { est = Number(it.final_price) / 100 / VAT; how = 'färdigt plagg'; }
      if (est != null) { total += est * it.quantity; lines.push('- ' + it.quantity + ' st ' + name + ': ca ' + kr(est) + '/st ' + how); }
      else { unknown++; lines.push('- ' + it.quantity + ' st ' + name + ': pris enligt offert'); }
    });
    var txt = 'Förfrågan från varukorgen (' + qtyAll + ' st):\n' + lines.join('\n') +
      '\nUppskattat totalt ca ' + kr(total) + ' exkl. moms' + (unknown ? ' + ' + unknown + ' rad(er) enligt offert' : '') + '. Slutpris bekräftas med mockup.' +
      (anyLogo ? '\nTeknik/placering (tryck eller brodyr, var på plagget): ' : '');
    return { text: txt, total: total, qty: qtyAll, unknown: unknown };
  }

  var last = null, fetching = false, lastFetch = 0;
  function refresh(force) {
    var now = Date.now();
    if (fetching || (!force && now - lastFetch < 1200)) { render(); return; }
    fetching = true; lastFetch = now;
    fetch('/cart.js', { credentials: 'same-origin', headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { last = summarize(cart); render(); })
      .catch(function () {})
      .then(function () { fetching = false; });
  }

  function render() {
    var cos = document.querySelectorAll(CHECKOUT_SEL);
    for (var i = 0; i < cos.length; i++) {
      var co = cos[i];
      if (co.closest('#abb-kepsstudio, .abb-ks')) continue;
      var host = co.parentElement; if (!host) continue;
      var box = host.querySelector(':scope > .abb-okorg');
      if (!last) { if (box) box.remove(); continue; }
      if (!box) {
        box = document.createElement('div'); box.className = 'abb-okorg'; box.setAttribute('data-abb-novat', '');
        box.innerHTML = '<p class="abb-okorg__text"><strong>Vill ni ha er logga på plaggen?</strong> Skicka varukorgen som förfrågan – bifoga loggan så får ni mockup och slutpris inom 24 h.</p>' +
          '<p class="abb-okorg__est" data-abb-okorg-est></p>' +
          '<button type="button" class="abb-okorg__btn" data-abb-open aria-haspopup="dialog" aria-controls="abb-quote-modal">Skicka förfrågan med logga</button>';
        host.insertBefore(box, co.nextSibling);
      }
      var btn = box.querySelector('[data-abb-open]');
      if (btn.getAttribute('data-abb-prefill-text') !== last.text) btn.setAttribute('data-abb-prefill-text', last.text);
      var est = box.querySelector('[data-abb-okorg-est]');
      var e = 'Uppskattat med logga: ca ' + kr(last.total) + ' exkl. moms' + (last.unknown ? ' + rader enligt offert' : '');
      if (est.textContent !== e) est.textContent = e;
    }
  }

  // Modalen saknas på vissa sidor → abb-home.js skickar då vidare till /pages/custom-merch?text=…
  var css = '.abb-okorg{margin:12px 0 0;padding:12px;border:1px solid rgba(70,162,79,.5);border-radius:10px;background:rgba(70,162,79,.08);display:grid;gap:8px}' +
    '.abb-okorg__text,.abb-okorg__est{margin:0;font-size:13.5px;line-height:1.45}.abb-okorg__est{font-weight:600}' +
    '.abb-okorg__btn{appearance:none;border:0;border-radius:999px;padding:12px 16px;background:#46a24f;color:#0b0c0a;font:inherit;font-weight:700;cursor:pointer;width:100%}' +
    '.abb-okorg__btn:hover{filter:brightness(1.08)}.abb-okorg__btn:focus-visible{outline:2px solid #46a24f;outline-offset:3px}';
  var st = document.createElement('style'); st.id = 'abb-okorg-css'; st.textContent = css; document.head.appendChild(st);

  var timer = null;
  function schedule() { if (timer) return; timer = setTimeout(function () { timer = null; refresh(false); }, 120); }
  ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(function () { refresh(true); }, 300); }); });
  function start() {
    refresh(true);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target; var el = t.nodeType === 3 ? t.parentElement : t;
        if (el && el.closest && el.closest('.abb-okorg, [data-abb-moms-tag], .abb-minorder, .abb-moms')) continue;
        schedule(); return;
      }
    }).observe(document.body, { subtree: true, childList: true });
  }
  window.ABBOffertkorg = { version: VERSION, summarize: summarize, refresh: function () { refresh(true); }, last: function () { return last; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
